export default [
	{
		path: '/remind/list',
		name: 'remindList',
		component: () => import('@/views/remind/list.vue'),
		meta: { title: '服药提醒' }
	},
    {
		path: '/remind/add/:id?',
		name: 'remindAdd',
		component: () => import('@/views/remind/add.vue'),
		meta: { title: '服药打卡' }
	},
	{
		path: '/takeMedicine/list/:id?/:type?',
		name: 'takeMedicine',
		component: () => import('@/views/remind/take-medicine.vue'),
		meta: { title: '服药记录' }
	},
	{
		path: '/takeMedicine/detail/:id',
		name: 'medicineDetail',
		component: () => import('@/views/remind/medicine-detail.vue'),
		meta: { title: '服药打卡' }
	},
]
